import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import tw, { styled } from 'twin.macro';

import { breakpoints } from '@ubisend/pulse-components';

import { Content, Embed, Section } from './ResponseTypes/index';

const types = {
  content: Content,
  embed: Embed
};

const MessagePanel = styled.div`
  ${tw`relative w-full bg-white lg:h-full flex flex-col text-black lg:overflow-y-auto w-full`}
  box-sizing: border-box;
  height: 25vh;
  max-width: 100%;
  overflow-wrap: break-word;

  @media (min-width: ${breakpoints.xl}px) {
    width: 40rem;
    flex-shrink: 0;
  }
`;

const ContentMessage = ({ content, sectionFromApi, isDemo = false }) => {
  const Component = useMemo(() => types[content?.type], [content?.type]);

  if (sectionFromApi) {
    return (
      <MessagePanel layout layoutId="panel">
        <Section sectionId={sectionFromApi} isDemo={isDemo} />
      </MessagePanel>
    );
  }

  return (
    <MessagePanel layout layoutId="panel">
      <Component content={content} isDemo={isDemo} />
    </MessagePanel>
  );
};

ContentMessage.propTypes = {
  sectionFromApi: PropTypes.string,
  content: PropTypes.shape({
    type: PropTypes.string.isRequired,
    content: PropTypes.object.isRequired
  }),
  isDemo: PropTypes.bool,
};

export default ContentMessage;
